import AxiosService from "../AxiosService";

export class ClientService {
  constructor() {
    this.service = new AxiosService();
  }

  resolveClients() {
    return this.service.get(`/api/clients`);
  }

  resolveClient(id) {
    return this.service.get(`/api/clients/${id}`);
  }

  addEmailAddress(id, emailAddress) {
    return this.service.post(`/api/clients/${id}`, {"emailAddress": emailAddress});
  }

  saveClient(name) {
    return this.service.post(`/api/clients`, {"name": name});
  }

  createSurvey(id, nameSurvey) {
    return this.service.post(`/api/clients/${id}/surveys`, {"name": nameSurvey});
  }

  resolveCookie(clientId, surveyId) {
    return this.service.post(`/api/resolve-cookie`, {"clientId": clientId, "surveyId": surveyId, "recordId": "new-record"})
  }
}
